import type {BestOfferTypeName} from '@/redux/middleware/googleTagManager/types';

import {
  BEST_OFFER_TYPE_BESTVALUE,
  BEST_OFFER_TYPE_CHEAPEST,
  BEST_OFFER_TYPE_PREMIUM,
  BEST_OFFER_TYPE_SPONSORED,
} from '@/redux/v1/offers/list/models';

const BEST_OFFER_NAME_MAP = {
  [BEST_OFFER_TYPE_BESTVALUE]: 'best value',
  [BEST_OFFER_TYPE_CHEAPEST]: 'best price',
  [BEST_OFFER_TYPE_PREMIUM]: 'premium',
  [BEST_OFFER_TYPE_SPONSORED]: 'sponsored',
} as const;

export type BestOfferType = keyof typeof BEST_OFFER_NAME_MAP;

export const mapBestOfferType = (type: BestOfferType): BestOfferTypeName =>
  BEST_OFFER_NAME_MAP[type];
